export default function validate(type, value, params) {
    const fns = {
        email: function(email) {
            const regexp = new RegExp("^((([0-9A-Za-z]{1}[-0-9A-z\\.]{0,30}[0-9A-Za-z]?)|([0-9А-Яа-я]{1}[-0-9А-я\\.]{0,30}[0-9А-Яа-я]?))@([-A-Za-z0-9]{1,}\\.){1,}[-A-Za-z]{2,})$");
            return regexp.test(email);
        },
        noempty: function(value) {
            if (typeof value !== 'string' ) {
                value = String(value)
            }
            return value.trim().length > 0;
        },
        hotel: function(value) {
            if (typeof value !== 'string' ) {
                value = String(value)
            }
            return value.trim().length > 0;
        },
        telNotMask: function(tel) {
            const regexp = /^(\d|\+)[\d\(\)\ -]{4,16}\d$/
            return regexp.test(tel);
        },
        tel: function(tel) {
            // +7 (999) 999-99-99
            const regexp = /^\+7\s\(\d{3}\)\s\d{3}-\d{2}-\d{2}$/
            return regexp.test(tel);
        },
        checkbox: function(value) {
            return value;
        },
        pass: function(value, params) {
            if (typeof value !== 'string' ) {
                value = String(value)
            }
            if (value.length < params.PASSWORD_LENGTH) {
                console.log('-- длина')
                return false
            }
            if (-1 !== value.search(/[\s]/)) {
                console.log('-- недопустимые символы')
                return false
            }
            if (params.PASSWORD_DIGITS === 'Y' && -1 === value.search(/[0-9]/)) {
                console.log('-- цифры')
                return false
            }
            if (params.PASSWORD_LOWERCASE === 'Y' && -1 === value.search(/[a-z]/)) {
                console.log('-- маленькие буквы')
                return false
            }
            if (params.PASSWORD_UPPERCASE === 'Y' && -1 === value.search(/[A-Z]/)) {
                console.log('-- большие буквы')
                return false
            }
            if (params.PASSWORD_PUNCTUATION === 'Y' && -1 === value.search(/[,.<>\/?;:'"\[\]{}\|`~!@#\$%\^&\*\(\)_\+=-]/)) {
                console.log('-- пунктуация')
                return false
            }
            return true;
        }
    }
    if (type in fns) {
        return fns[type](value, params)
    } else {
        console.log("ERR: No validate rule: " + type)
        return false;
    }
}